import { useMutation } from '@tanstack/react-query';
import placeFollowersService from '../services/placeFollowersService/place-followers.service';
import useUserContext from './useUserContext';

export const usePlaceFollowing = (placeId: string) => {
  const { user, updateUserOnClient } = useUserContext();

  const isFollowing = user?.followedPlaceIdList?.includes(placeId) ?? false;

  const { mutate: followPlace, isPending: isFollowingPending } = useMutation({
    mutationFn: () => placeFollowersService.followPlace(placeId),
    onSuccess: () => {
      updateUserOnClient({
        followedPlaceIdList: [...(user?.followedPlaceIdList ?? []), placeId],
      });
    },
  });

  const { mutate: unfollowPlace, isPending: isUnfollowingPending } = useMutation({
    mutationFn: () => placeFollowersService.unfollowPlace(placeId),
    onSuccess: () => {
      updateUserOnClient({
        followedPlaceIdList: user?.followedPlaceIdList?.filter((id) => id !== placeId),
      });
    },
  });

  return {
    isFollowing,
    followPlace,
    unfollowPlace,
    isLoading: isFollowingPending || isUnfollowingPending,
  };
}; 